import { useDispatch as useReactReduxDispatch } from "react-redux";
import { AppDispatch } from "store/store";

export const useDispatch = (): AppDispatch => useReactReduxDispatch();
